const NotSupported = () => null;

export default NotSupported;
